export const stringSorter = (left: string, right: string) =>
  left > right ? 1 : left < right ? -1 : 0;

export const numberSorter = (left: number, right: number) => {
  return left - right;
};
